import { ACCESS_LEVEL_VIEW } from "./constants";

const isComingSoon = ({ earlyAccess }) =>
  earlyAccess?.accessLevel === ACCESS_LEVEL_VIEW;

export default isComingSoon;
